module.exports = __webpack_public_path__ + "b3b3804cf923906443fe6035a9a0e1c9.png";